import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  type ReactNode,
} from 'react';

export type ThemeMode = 'light' | 'dark';

type ThemeContextValue = {
  mode: ThemeMode;
  dark: boolean;
  toggle: () => void;
  setMode: (mode: ThemeMode) => void;
};

const ThemeContext = createContext<ThemeContextValue | null>(null);

// Site kalıcı olarak koyu "akışkan metalik mavi" temada çalışır → liquid-metal
// arka plan her zaman görünür. Tema anahtarı kaldırıldı; API yine de korunur
// (mode/dark/toggle/setMode) ki mevcut tüketiciler kırılmasın.
export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('dark');
    root.style.colorScheme = 'dark';
    // Tarayıcı çubuğu / güvenli alan rengi sayfa zeminiyle aynı olsun
    // (index.html'deki meta her ortamda güncellenmeyebiliyor).
    const meta = document.querySelector<HTMLMetaElement>(
      'meta[name="theme-color"]',
    );
    if (meta) meta.content = '#03060f';
    // Kök tuval ŞEFFAF bırakılır (üst/alt şeritler boyanmaz); koyu görünüm
    // color-scheme: dark ile tarayıcının kendi tuvalinden gelir.
    document.documentElement.style.backgroundColor = '';
    document.body.style.backgroundColor = '';
  }, []);

  const noop = useCallback(() => {}, []);

  return (
    <ThemeContext.Provider
      value={{ mode: 'dark', dark: true, toggle: noop, setMode: noop }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextValue => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme, ThemeProvider içinde kullanılmalıdır');
  return ctx;
};
